import React from 'react';
import { motion } from 'framer-motion';
import { ORIGIN_TOKENS } from './tokens';

/**
 * OriginModule — The 40x40px signature module.
 * Serves as a constant visual anchor across the ecosystem.
 */
const OriginModule: React.FC = () => {
  const MotionDiv = motion.div as any;
  return (
    <MotionDiv
      className="origin-module"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] } as any}
      style={{
        width: 'var(--origin-module-size)',
        height: 'var(--origin-module-size)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--origin-glass-bg)',
        backdropFilter: 'blur(var(--origin-glass-blur))',
        WebkitBackdropFilter: 'blur(var(--origin-glass-blur))',
        borderRadius: 'var(--origin-radius-soft)',
        border: '1px solid var(--origin-glass-border)',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: 'var(--origin-shadow-soft)'
      }}
    >
      {/* Visual content - centered square diamond */}
      <div 
        style={{
          width: '12px',
          height: '12px',
          background: 'var(--color-accent-500)',
          borderRadius: '2px',
          transform: 'rotate(45deg)',
          boxShadow: '0 0 10px var(--color-accent-500)'
        }}
      />
      
      {/* Decorative scan line effect to denote 'system' quality */}
      <MotionDiv
        animate={{
          top: ['-100%', '200%']
        } as any}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "linear"
        } as any}
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          height: '1px',
          background: 'rgba(255, 255, 255, 0.2)',
          zIndex: 1
        }}
      />
    </MotionDiv>
  );
};

export default OriginModule;
